/*
 * @Descripttion: 开票申请详情-订单详情/物料明细模块
 * @Author: renbh
 * @Date: 2023-02-03 14:03:51
 * @LastEditors: renbh
 * @LastEditTime: 2023-02-16 11:08:27
 */

import React from 'react'
import TableAntd from '../../components/TableAntd'
import style from './invoiceOrderInfo.module.scss'
import { Tabs } from 'antd'
import { orderDetailLinkRender } from '../../pages/orderassurance/Lander'
import { signVoucherStateDict } from '../../tools/state'
import Tippy from '@tippyjs/react'
import { QuestionCircleOutlined } from '@ant-design/icons'

interface Props {
  onChangeTab?: (activeKey: string) => void // 切换tab
  materialData: any[] // 物料明细表格数据
  orderData: any[] // 订单信息表格数据
}

const InvoiceOrderInfo: React.FC<Props> = (props) => {
  const { materialData, orderData, onChangeTab } = props

  // 订单信息
  const orderColumns = [
    {
      key: 'orderNo',
      dataIndex: 'orderNo',
      title: '客户订单号',
      render: orderDetailLinkRender,
    },
    {
      key: 'customer',
      dataIndex: 'customer',
      title: '客户名称',
    },
    {
      key: 'platform',
      dataIndex: 'platform',
      title: '下单平台',
    },
    {
      key: 'createTime',
      dataIndex: 'createTime',
      title: '下单时间',
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '下单金额',
      titleRender: (
        <div>
          <span>下单金额</span>
          <Tippy
            content={
              <div className={'tooltip-card'}>
                此为咸亨给您的下单金额，并非客户的下单金额，也并非实际开票金额
              </div>
            }
          >
            <QuestionCircleOutlined />
          </Tippy>
        </div>
      ),
    },
    {
      key: 'signVoucherState',
      dataIndex: 'signVoucherState',
      title: '签收凭证',
      render: (text: any) => {
        return <span>{(signVoucherStateDict as any)?.[text]}</span>
      },
    },
  ]

  // 物料明细表格
  const materialListColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: (text: any, record: any, index: number) => index + 1,
      width: 50,
    },
    {
      key: 'code',
      dataIndex: 'code',
      title: '物料编码',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '商品名称',
    },
    {
      key: 'model',
      dataIndex: 'model',
      title: '型号',
    },
    {
      key: 'num',
      dataIndex: 'num',
      title: '数量',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '单价',
    },
    {
      key: 'orderNo',
      dataIndex: 'orderNo',
      title: '客户订单号',
    },
  ]

  return (
    <Tabs onChange={onChangeTab} className={style['invoice-tab']}>
      <Tabs.TabPane key="ORDERINFO" tab="订单信息">
        <TableAntd
          dataSource={orderData}
          loading={false}
          listColumn={orderColumns}
          selfAdaptScroll
        />
      </Tabs.TabPane>
      <Tabs.TabPane key="MATERIALDETAIL" tab="物料明细">
        <TableAntd
          dataSource={materialData}
          loading={false}
          listColumn={materialListColumn}
          selfAdaptScroll
        />
      </Tabs.TabPane>
    </Tabs>
  )
}
export default InvoiceOrderInfo
/*
 * @Descripttion: 开票申请详情-订单详情/物料明细模块
 * @Author: renbh
 * @Date: 2023-02-03 14:03:51
 * @LastEditors: renbh
 * @LastEditTime: 2023-02-16 11:08:27
 */

import React from 'react'
import TableAntd from '../../components/TableAntd'
import style from './invoiceOrderInfo.module.scss'
import { Tabs } from 'antd'
import { orderDetailLinkRender } from '../../pages/orderassurance/Lander'
import { signVoucherStateDict } from '../../tools/state'
import Tippy from '@tippyjs/react'
import { QuestionCircleOutlined } from '@ant-design/icons'

interface Props {
  onChangeTab?: (activeKey: string) => void // 切换tab
  materialData: any[] // 物料明细表格数据
  orderData: any[] // 订单信息表格数据
}

const InvoiceOrderInfo: React.FC<Props> = (props) => {
  const { materialData, orderData, onChangeTab } = props

  // 订单信息
  const orderColumns = [
    {
      key: 'orderNo',
      dataIndex: 'orderNo',
      title: '客户订单号',
      render: orderDetailLinkRender,
    },
    {
      key: 'customer',
      dataIndex: 'customer',
      title: '客户名称',
    },
    {
      key: 'platform',
      dataIndex: 'platform',
      title: '下单平台',
    },
    {
      key: 'createTime',
      dataIndex: 'createTime',
      title: '下单时间',
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '下单金额',
      titleRender: (
        <div>
          <span>下单金额</span>
          <Tippy
            content={
              <div className={'tooltip-card'}>
                此为咸亨给您的下单金额，并非客户的下单金额，也并非实际开票金额
              </div>
            }
          >
            <QuestionCircleOutlined />
          </Tippy>
        </div>
      ),
    },
    {
      key: 'signVoucherState',
      dataIndex: 'signVoucherState',
      title: '签收凭证',
      render: (text: any) => {
        return <span>{(signVoucherStateDict as any)?.[text]}</span>
      },
    },
  ]

  // 物料明细表格
  const materialListColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: (text: any, record: any, index: number) => index + 1,
      width: 50,
    },
    {
      key: 'code',
      dataIndex: 'code',
      title: '物料编码',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '商品名称',
    },
    {
      key: 'model',
      dataIndex: 'model',
      title: '型号',
    },
    {
      key: 'num',
      dataIndex: 'num',
      title: '数量',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '单价',
    },
    {
      key: 'orderNo',
      dataIndex: 'orderNo',
      title: '客户订单号',
    },
  ]

  return (
    <Tabs onChange={onChangeTab} className={style['invoice-tab']}>
      <Tabs.TabPane key="ORDERINFO" tab="订单信息">
        <TableAntd
          dataSource={orderData}
          loading={false}
          listColumn={orderColumns}
          selfAdaptScroll
        />
      </Tabs.TabPane>
      <Tabs.TabPane key="MATERIALDETAIL" tab="物料明细">
        <TableAntd
          dataSource={materialData}
          loading={false}
          listColumn={materialListColumn}
          selfAdaptScroll
        />
      </Tabs.TabPane>
    </Tabs>
  )
}
export default InvoiceOrderInfo
